import React, { InputHTMLAttributes, Ref, forwardRef } from 'react';

interface InputProps extends InputHTMLAttributes<HTMLInputElement> {
  hasError?: boolean;
}

/**
 * readOnly/disabled 는 :read-only 변형 대신 prop 으로 분기한다.
 * CSS :read-only 는 disabled 인 input 에도 매칭돼 원본과 동작이 달라진다.
 *
 * 기본 타이포그래피는 globals.css 의 .form-input-base 에 있다.
 * 유틸리티로 두면 caller 가 leading 등을 덮어쓸 수 없다 (전부 !important 라
 * 승자가 className 순서가 아니라 CSS 출력 순서로 정해진다).
 */
const BASE = 'form-input-base';

const Input = forwardRef<HTMLInputElement, InputProps>(
  (
    {
      type,
      disabled,
      readOnly,
      hasError,
      className,
      'aria-invalid': ariaInvalid,
      ...props
    },
    ref: Ref<HTMLInputElement>,
  ) => {
    return (
      <input
        type={type}
        ref={ref}
        disabled={disabled}
        readOnly={readOnly}
        aria-invalid={hasError || ariaInvalid}
        className={`${BASE} ${
          readOnly
            ? 'pointer-events-none bg-apps-coreProductDisableContainer text-apps-coreGrayBlack'
            : ''
        } ${
          disabled
            ? 'bg-apps-coreProductDisableContainer text-apps-coreProductDisableContent'
            : ''
        } ${className ?? ''}`}
        {...props}
      />
    );
  },
);

Input.displayName = 'Input';

export default Input;
